import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {getInventoryReportT, getInventoryReportWDate} from "./inventoryReportAPI";

const initialState = {
    value: [],
    status: "idle",
    editStatus: "idle",
    startDate: new Date(),
    endDate: new Date(),
};



export const retrieveITodaysReport = createAsyncThunk("locations/getInventoryReport", async() => {
    const response = await getInventoryReportT();
    return response;
});

export const retrieveInventoryReportWDate = createAsyncThunk("locations/getInventoryReportWDate", async(data) => {
    const response = await getInventoryReportWDate(data);
    return response;
});

export const inventoryReportsSlice = createSlice({
    name: "inventoryReports",
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        modifyDates: (state, action) => {
            console.log('This is payload: ', action.payload)
            state.startDate = action.payload[0];
            state.endDate = action.payload[1];
            //[state.startDate, state.endDate] = action.payload
        },
        
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: {
        [retrieveITodaysReport.pending]: (state, action) => {
            state.status = "loading";
        },
        [retrieveITodaysReport.fulfilled]: (state, action) => {
            state.status = "succeeded";
            if (action.payload.message){
                if (action.payload.message === "Unathorized"){
                    state.value = []
                }
            } else {
                state.value = action.payload;
            }
        },
        [retrieveITodaysReport.rejected]: (state, action) => {
            state.status = "failed";
            state.error = action.error.message;
        },


        [retrieveInventoryReportWDate.pending]: (state, action) => {
            state.status = "loading";
        },
        [retrieveInventoryReportWDate.fulfilled]: (state, action) => {
            state.status = "succeeded";
            state.value = [];
            if (action.payload.message){
                if (action.payload.message === "Unathorized"){
                    state.value = []
                }
            } else {
                state.value = action.payload;
            }
            debugger;
        },
        [retrieveInventoryReportWDate.rejected]: (state, action) => {
            state.status = "failed";
            state.error = action.error.message;
        },

    },
});

export const { modifyDates } = inventoryReportsSlice.actions;

export const selectAllReports = (state) => state.inventoryReports.value;


export default inventoryReportsSlice.reducer;